<template>
   <div class="row">
        <div class="col-md-8">
            <div class="table-responsive p-0">
                <table class="table table-bordered">
                    <tr>
                        <th>{{$t('form.student.file')}}</th>
                        <th>{{$t('form.student.UploadTimestamp')}}</th>
                        <th>{{$t('form.student.fileName')}}</th>
                        <th>{{$t('form.student.fileDescription')}}</th>
                        <th v-if="!readonly"></th>
                    </tr>
                    <tbody>
                        <tr v-for="(file , index) in attachments" v-bind:key="index">
                            <td class="text-center">
                                <i class="fa fa-file" aria-hidden="true"></i>
                            </td>
                            <td class="text-center">
                              {{file.UploadTimestamp}}
                            </td>
                            <td>
                                <a href="#" 
                                    @click.prevent="downloadAttachment(file , true)" class="mr-2">{{getAttachmentFileName(file.Name)}}</a>

                                | <a href="#" @click.prevent="downloadAttachment(file)" class="ml-2"> {{$t('button.view')}}</a>
                            </td>
                            <td>
                                <input type="text" class="form-control" :disabled="!permissions.editStudentsAttachments && !isPartnerSchoolUser"
                                    v-model="attachments[index].Description">
                            </td>
                            <td v-if="!readonly">
                                <span style="color:red;cursor:pointer" :disabled="!permissions.editStudentsAttachments"
                                    @click="removeAttachment(index,file)">
                                    <i class="fa fa-times"></i>
                                </span>
                            </td>
                        </tr>
                    </tbody>
                </table>
            </div>
        </div>

        <div class="col-md-4" v-if="isPartnerSchoolUser || permissions.editStudentsAttachments">
            <div class="form-group">
                <label for="StatusID:">{{$t('form.student.fileAttach')}}</label>
                <vue-dropzone ref="attachmentVueDropzone" id="dropzone"
                    :options="attachmentDropzone" @vdropzone-success="attachmentUploaded"
                    @vdropzone-error="uploadFileError" @vdropzone-processing="isLoading=true"
                    v-on:vdropzone-sending="sendingEvent">
                </vue-dropzone>
            </div>
        </div>
    </div>
</template>


<script>

import vue2Dropzone from "vue2-dropzone";

export default {
name:'StudentApplication',
 props: { readonly:Boolean, attachments:Array, downloadAttachment:Function, removeAttachment:Function, attachmentUploaded:Function, attachmentDropzone:Object, permissions:Object, sendingEvent:Function, getAttachmentFileName:Function, uploadFileError:Function, isPartnerSchoolUser:Boolean },

components: {
      vueDropzone: vue2Dropzone,
    },
}
</script>
<style scoped>
.disabledAnchor {
  cursor: not-allowed !important;
  pointer-events: none !important;
  color: gray
}
</style>
